import React from 'react';

const PJJMeter = ({ width = '16', height = '16', className, ...rest }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      role="presentation"
      aria-hidden="true"
      {...rest}
    >
      <g clip-path="url(#clip0_4379_81582)">
        <path
          d="M11.1723 0.0758927C10.8897 0.224266 10.4201 0.643367 9.85938 1.25126L10.3746 2.11437C10.7363 1.65541 11.1037 1.2424 11.4741 0.889734C11.5028 0.861498 11.5178 0.848211 11.5178 0.848211C11.5035 0.862052 11.4891 0.875893 11.4741 0.889734C11.3544 1.0071 10.9908 1.38357 10.4419 2.13209C10.9702 2.10883 11.7822 2.0125 12.4446 1.91229C12.6417 0.932363 12.2513 0.48392 12.2513 0.48392C12.2513 0.48392 11.7542 -0.229159 11.1723 0.0758927Z"
          fill="url(#paint0_linear_4379_81582)"
        />
        <path
          d="M9.43832 7.32462C9.37221 7.33513 9.30485 7.34565 9.23562 7.35617C9.235 7.35617 9.235 7.35673 9.23438 7.35673C9.2693 7.3523 9.30423 7.34731 9.33791 7.34233C9.37221 7.3368 9.40527 7.33071 9.43832 7.32462Z"
          fill="#BE202E"
        />
        <path
          opacity="0.35"
          d="M9.43832 7.32462C9.37221 7.33513 9.30485 7.34565 9.23562 7.35617C9.235 7.35617 9.235 7.35673 9.23438 7.35673C9.2693 7.3523 9.30423 7.34731 9.33791 7.34233C9.37221 7.3368 9.40527 7.33071 9.43832 7.32462Z"
          fill="#BE202E"
        />
        <path
          d="M9.61062 6.57001C9.61 6.57001 9.61 6.57001 9.61062 6.57001C9.61 6.57057 9.60938 6.57057 9.60938 6.57057C9.6206 6.56946 9.6312 6.5678 9.64181 6.56614C9.68547 6.5606 9.7285 6.55396 9.77091 6.54565C9.7179 6.55396 9.66488 6.56171 9.61062 6.57001Z"
          fill="#BE202E"
        />
        <path
          opacity="0.35"
          d="M9.61062 6.57001C9.61 6.57001 9.61 6.57001 9.61062 6.57001C9.61 6.57057 9.60938 6.57057 9.60938 6.57057C9.6206 6.56946 9.6312 6.5678 9.64181 6.56614C9.68547 6.5606 9.7285 6.55396 9.77091 6.54565C9.7179 6.55396 9.66488 6.56171 9.61062 6.57001Z"
          fill="#BE202E"
        />
        <path
          d="M8.85457 4.3444C9.01112 4.08475 9.16954 3.83063 9.32983 3.58371C9.49636 3.32682 9.66476 3.07824 9.83441 2.83796C9.84439 2.82357 9.85437 2.80918 9.86435 2.79533C10.0327 2.55893 10.2024 2.33194 10.3733 2.11492L9.85811 1.25125C9.81944 1.29333 9.78015 1.33596 9.74085 1.37969C9.59241 1.54412 9.43773 1.72073 9.27994 1.90841C9.10156 2.1199 8.91819 2.34523 8.73233 2.58219C8.56019 2.80087 8.38617 3.03007 8.21154 3.26703C8.0631 3.46911 7.91403 3.67672 7.76622 3.88987C7.7606 3.89762 7.75499 3.90592 7.75 3.91367L8.42048 5.08904C8.56268 4.83658 8.708 4.588 8.85457 4.3444Z"
          fill="url(#paint1_linear_4379_81582)"
        />
        <path
          d="M5.79981 10.9675C5.71124 11.184 5.62205 11.4043 5.53224 11.6297C5.53099 11.633 5.52975 11.6363 5.5285 11.6396C5.51602 11.6712 5.50293 11.7033 5.49045 11.7348C5.42995 11.8865 5.37819 12.0233 5.25781 12.3339C5.45553 12.4142 5.61395 12.6245 5.76363 12.8632C5.74742 12.6157 5.63266 12.3837 5.41311 12.2038C6.38671 12.2425 7.22559 12.0244 7.65906 11.3921C7.69773 11.3357 7.73328 11.2764 7.76509 11.2139C7.568 11.4359 7.32351 11.53 6.86384 11.5073C7.54118 11.2382 7.8811 10.9797 8.1811 10.5517C8.2522 10.4504 8.32143 10.3391 8.39191 10.2162C7.80002 10.756 7.11332 10.9099 6.39045 10.7931L5.84846 10.8457C5.83349 10.8861 5.81665 10.9265 5.79981 10.9675Z"
          fill="url(#paint2_linear_4379_81582)"
        />
        <path
          d="M6.05724 9.8896C6.17449 9.62109 6.29487 9.3487 6.41898 9.07465C6.53749 8.81223 6.65911 8.5476 6.78385 8.28185C6.90859 8.01611 7.03582 7.74981 7.16555 7.48351C7.29778 7.21223 7.43312 6.94206 7.57034 6.67244C7.7063 6.40614 7.84476 6.14151 7.98572 5.87908C8.03624 5.78441 8.08738 5.69029 8.13915 5.59673C8.22772 5.43452 8.31753 5.27341 8.40797 5.11396C8.41295 5.1051 8.41794 5.0968 8.42293 5.0885L7.75246 3.91313C7.74123 3.92919 7.73063 3.94524 7.7194 3.96074C7.56285 4.18718 7.40755 4.4186 7.25537 4.655C7.10131 4.89362 6.94975 5.13721 6.80194 5.38414C6.6772 5.5923 6.55495 5.80268 6.43645 6.01472C6.41275 6.05791 6.38905 6.10054 6.36597 6.14317C6.22002 6.41002 6.0878 6.66801 5.96867 6.91548C5.83333 7.19618 5.71483 7.46469 5.61004 7.71881C5.54144 7.886 5.47907 8.04767 5.42231 8.20268C5.37553 8.33555 5.33063 8.46787 5.28821 8.60019C5.18842 8.91189 5.10173 9.22247 5.03125 9.53196L5.70422 10.7134C5.79341 10.5025 5.88447 10.2882 5.97865 10.0712C6.00422 10.0108 6.03104 9.9505 6.05724 9.8896Z"
          fill="url(#paint3_linear_4379_81582)"
        />
        <path
          d="M5.01871 9.57458C4.93389 9.95216 4.87401 10.3286 4.84407 10.7029C4.84283 10.7162 4.84158 10.7289 4.84096 10.7422C4.63077 10.4432 4.06757 10.1509 4.06881 10.1542C4.47173 10.673 4.77796 11.1879 4.82287 11.6933C4.60707 11.7326 4.31143 11.6756 3.96965 11.5643C4.32578 11.855 4.59335 11.9353 4.69751 11.9569C4.37006 11.9751 4.02952 12.1744 3.68649 12.4042C4.18857 12.2226 4.59397 12.1506 4.88462 12.2088C4.4237 13.3659 3.96216 14.6436 3.5 16C3.64158 15.963 3.72578 15.8788 3.7738 15.7642C3.85613 15.5184 4.40249 13.9062 5.25821 11.788C5.28254 11.7277 5.30686 11.6673 5.33181 11.6059C5.33867 11.5892 5.34553 11.5721 5.35239 11.5549C5.44283 11.3329 5.53638 11.1059 5.63368 10.8745C5.65551 10.8219 5.67796 10.7693 5.70042 10.7162C5.70104 10.7151 5.70104 10.714 5.70166 10.7128L5.02869 9.5325C5.02557 9.5469 5.02183 9.56074 5.01871 9.57458Z"
          fill="url(#paint4_linear_4379_81582)"
        />
        <path
          d="M8.52412 5.1876C8.50478 5.22247 8.48545 5.25791 8.46612 5.29334C8.40811 5.39964 8.34886 5.50815 8.28961 5.61888C8.22537 5.73901 8.1605 5.86192 8.09439 5.98704C8.06133 6.05016 8.02828 6.11382 7.9946 6.1786C7.89418 6.37237 7.79252 6.57223 7.68961 6.77818C7.563 7.03175 7.43389 7.29528 7.30291 7.56877C7.17817 7.82953 7.05156 8.09971 6.92308 8.37874C6.80146 8.64393 6.67797 8.91742 6.55323 9.19978C6.44221 9.45112 6.32932 9.70967 6.21643 9.97542C6.21081 9.98815 6.2052 10.0014 6.20021 10.0142C6.08794 10.2777 5.97443 10.549 5.85967 10.8269C5.85718 10.833 5.85468 10.8396 5.85156 10.8457L6.39356 10.7931C6.38296 10.7915 6.37173 10.7904 6.36113 10.7881C7.00915 10.7162 7.87111 10.2866 8.42807 9.75562C8.68441 9.51092 8.91767 9.22247 9.13285 8.88476C9.29314 8.63341 9.44345 8.35438 9.58691 8.046C9.71227 7.77638 9.83264 7.48462 9.94865 7.16794C9.79959 7.2377 9.62932 7.28863 9.44096 7.32407C9.4079 7.33016 9.37422 7.33625 9.34054 7.34123C9.30624 7.34676 9.27194 7.35119 9.23701 7.35562C9.23763 7.35562 9.23763 7.35507 9.23826 7.35507C9.84262 7.14856 10.2237 6.7505 10.5006 6.2622C10.3416 6.35853 10.0834 6.4842 9.77339 6.5451C9.7316 6.55341 9.68794 6.56005 9.64429 6.56559C9.63368 6.56725 9.62246 6.56891 9.61185 6.57002C9.61248 6.57002 9.61248 6.57002 9.61248 6.56946H9.6131C9.82266 6.4914 9.9998 6.40448 10.1532 6.30151C10.1863 6.27936 10.2181 6.25666 10.2487 6.23341C10.2954 6.19742 10.3403 6.15978 10.3827 6.11991C10.4102 6.09445 10.4364 6.06843 10.462 6.0413C10.5218 5.97763 10.5786 5.90898 10.631 5.83479C10.6472 5.81209 10.6628 5.78884 10.6784 5.76503C10.6983 5.73071 10.7177 5.69694 10.7364 5.66372C10.8206 5.51313 10.8886 5.3786 10.9422 5.26067C10.969 5.20199 10.9927 5.14718 11.0127 5.09625C11.0208 5.07576 11.0283 5.05638 11.0358 5.03756C11.057 4.98109 11.0744 4.93071 11.0882 4.88642C11.1087 4.81998 11.1212 4.76739 11.1281 4.72919C11.1075 4.74358 11.0838 4.75798 11.0576 4.77182C10.8748 4.8687 10.5617 4.95673 10.3098 4.9977C10.306 4.99825 10.3023 4.99881 10.2985 4.99936C10.2736 5.00324 10.248 5.00656 10.2225 5.01043C10.2268 5.00877 10.2312 5.00656 10.2356 5.0049L8.53285 5.17043C8.53036 5.17652 8.52724 5.18206 8.52412 5.1876Z"
          fill="url(#paint5_linear_4379_81582)"
        />
        <path
          d="M10.4392 2.13208C10.2876 2.33859 10.1223 2.57278 9.94393 2.83797C9.93458 2.85181 9.92522 2.8662 9.91587 2.88004C9.76244 3.1098 9.59903 3.36226 9.42751 3.63852C9.27907 3.87714 9.12501 4.13292 8.9641 4.40807C8.82439 4.64779 8.67969 4.90191 8.53125 5.17098L10.234 5.00544C10.7298 4.80281 10.9518 4.61956 11.167 4.35437C11.2244 4.28129 11.2818 4.20489 11.3385 4.12572C11.5132 3.88323 11.6853 3.61638 11.8381 3.35119C11.9859 3.09485 12.1169 2.84074 12.2167 2.61208C12.2803 2.46648 12.3315 2.33084 12.367 2.21181C12.3982 2.10662 12.4225 2.00752 12.4412 1.91229C11.7801 2.0125 10.9674 2.10883 10.4392 2.13208Z"
          fill="url(#paint6_linear_4379_81582)"
        />
        <path
          d="M9.33791 7.34178C9.30361 7.34732 9.2693 7.35175 9.23438 7.35618C9.2693 7.3523 9.30361 7.34732 9.33791 7.34178Z"
          fill="#BE202E"
        />
        <path
          opacity="0.35"
          d="M9.33791 7.34178C9.30361 7.34732 9.2693 7.35175 9.23438 7.35618C9.2693 7.3523 9.30361 7.34732 9.33791 7.34178Z"
          fill="#BE202E"
        />
        <path
          d="M9.33791 7.34178C9.30361 7.34732 9.2693 7.35175 9.23438 7.35618C9.2693 7.3523 9.30361 7.34732 9.33791 7.34178Z"
          fill="url(#paint7_linear_4379_81582)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4379_81582"
          x1="10.2958"
          y1="1.35717"
          x2="13.9983"
          y2="0.19746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F69923" />
          <stop offset="0.3123" stopColor="#F79A23" />
          <stop offset="0.8383" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4379_81582"
          x1="2.0344"
          y1="16.3926"
          x2="8.32083"
          y2="1.20458"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4379_81582"
          x1="4.61102"
          y1="15.3121"
          x2="8.35713"
          y2="6.26147"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#282662" />
          <stop offset="0.0954839" stopColor="#662E8D" />
          <stop offset="0.7882" stopColor="#9F2064" />
          <stop offset="0.9487" stopColor="#CD2032" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4379_81582"
          x1="2.31521"
          y1="15.5084"
          x2="8.60165"
          y2="0.320367"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4379_81582"
          x1="3.09521"
          y1="14.5348"
          x2="6.39892"
          y2="6.55308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#282662" />
          <stop offset="0.0954839" stopColor="#662E8D" />
          <stop offset="0.7882" stopColor="#9F2064" />
          <stop offset="0.9487" stopColor="#CD2032" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4379_81582"
          x1="4.01602"
          y1="16.2136"
          x2="10.3025"
          y2="1.02557"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4379_81582"
          x1="3.45363"
          y1="17.085"
          x2="9.74007"
          y2="1.89702"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4379_81582"
          x1="4.52013"
          y1="16.4232"
          x2="10.8065"
          y2="1.23534"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <clipPath id="clip0_4379_81582">
          <rect width="9" height="16" fill="white" transform="translate(3.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PJJMeter;
